import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import $ from 'jquery';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import lastOperationsIcon from './../img/last-operations-icon.png';
import { request } from '../../../config';
import YesNoModal from "../../../copms/Modal/YesNoModal"

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class History extends Component {
    state = {
        status: 1,
        excelFileOutline: false,
        startDate: null,
        endDate: null,
        currentPage: 1,
        lastPage: 0,
        formData: {
            services: [],
            status: []
        },
        applications: [],
        item: null,
        loading: false
    }

    downloadFile = (bytes) => {
        let arrrayBuffer = base64ToArrayBuffer(bytes); //data is the base64 encoded string
        saveFile(this.props.t('Template'), "application/xlsx", arrrayBuffer)
    }

    getBase64(file, cb) {
        if (file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                cb(reader.result)
            };
            reader.onerror = function (error) {

            };
        }
    }

    setValues = (value, name) => {
        let newFormData = {
            ...this.state.formData,
            [name]: value
        };
        this.setState({ formData: newFormData })
    };

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    getFormatedDate(date) {
        if (date) {
            let formatedDate = {
                day: (date.getDate() < 9) ? ('0' + date.getDate()) : date.getDate(),
                month: (date.getMonth() < 9) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1),
                year: date.getFullYear().toString()
            }
            return formatedDate.year + '-' + formatedDate.month + '-' + formatedDate.day;
        }
        return null;
    }

    selectPage(e, page) {
        e.preventDefault();
        this.setState({ currentPage: page }, () => this.getHistory())
    }

    componentDidMount() {
        this.getPayload();
    }

    getPayload = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getBatchSalaryPayloadRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
        }
        fetch(request("salary/getBatchSalaryPayload", getBatchSalaryPayloadRequestBody))
            .then(res => res.text())
            .then((getBatchSalaryPayloadResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getBatchSalaryPayloadResponse = JSON.parse(getBatchSalaryPayloadResponseJSON);
                if (getBatchSalaryPayloadResponse.status.statusCode != 1) {
                    if (getBatchSalaryPayloadResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getBatchSalaryPayloadResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({ payload: getBatchSalaryPayloadResponse.payload }, () => this.getHistory());
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getHistory = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getSalaryApplicationsRequestBody = {
            token: localStorage.getItem('token'),
            beginDate: this.getFormatedDate(this.state.startDate),
            endDate: this.getFormatedDate(this.state.endDate),
            pageNumber: this.state.currentPage,
            services: this.state.formData.services.map(item => item.id),
            status: this.state.formData.status.map(item => item.id),
        }
        fetch(request("salary/getBatchSalaryApplicationsHistory", getSalaryApplicationsRequestBody))
            .then(res => res.text())
            .then((getSalaryApplicationsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getSalaryApplicationsResponse = JSON.parse(getSalaryApplicationsResponseJSON);
                if (getSalaryApplicationsResponse.status.statusCode !== 1) {
                    if (getSalaryApplicationsResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getSalaryApplicationsResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({
                        lastPage: getSalaryApplicationsResponse.totalPage,
                        applications: getSalaryApplicationsResponse.applications || []
                    });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getFile = (id, serviceId, fileType) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getBatchSalaryFileByIdRequestBody = {
            token: localStorage.getItem('token'),
            id, serviceId, fileType
        }
        fetch(request("salary/getBatchSalaryFileById", getBatchSalaryFileByIdRequestBody))
            .then(res => res.text())
            .then((getBatchSalaryFileByIdResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getBatchSalaryFileByIdResponse = JSON.parse(getBatchSalaryFileByIdResponseJSON);
                if (getBatchSalaryFileByIdResponse.status.statusCode !== 1) {
                    if (getBatchSalaryFileByIdResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getBatchSalaryFileByIdResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    let arrrayBuffer = base64ToArrayBuffer(getBatchSalaryFileByIdResponse.file);
                    saveFile(getBatchSalaryFileByIdResponse.fileName, `application/${getBatchSalaryFileByIdResponse.fileName.substring(getBatchSalaryFileByIdResponse.fileName.lastIndexOf('.'))}`, arrrayBuffer)
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    deleteSalaryOrder = (id, serviceId) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let deleteSalaryOrderRequestBody = {
            token: localStorage.getItem('token'),
            id, serviceId
        }
        fetch(request("salary/deleteSalaryOrder", deleteSalaryOrderRequestBody))
            .then(res => res.text())
            .then((deleteSalaryOrderResponseJSON) => {
                const JSON = require('true-json-bigint');
                let deleteSalaryOrderResponse = JSON.parse(deleteSalaryOrderResponseJSON);
                if (deleteSalaryOrderResponse.status.statusCode !== 1) {
                    if (deleteSalaryOrderResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(deleteSalaryOrderResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(deleteSalaryOrderResponse.status.statusCode), null, null, this.getHistory());
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { payload, formData, applications, open, item } = this.state;
        let { t } = this.props;
        return (
            <>
                <YesNoModal open={open} title={t('Are you sure you want to delete the operation?')} onClose={() => this.setState({ open: false })} triggerFunc={(bool) => bool ? this.deleteSalaryOrder(item.id, item.serviceId) : this.setState({ open: false })} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('orders')}</h2>
                    </div>
                </div>
                <div className="dashboard-salary-container">
                    <div className="dashboard-salary-container-data-section" style={{ marginTop: '1px' }}>
                        <div className="dashboard-transfer-list-header">
                            <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                <NavLink exact to="/dashboard/salary-project/order" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Order")}</NavLink>
                                <NavLink exact to="/dashboard/salary-project/history" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("history")}</NavLink>
                                <NavLink exact to="/dashboard/salary-project/authorization" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("authorization")}</NavLink>
                                <NavLink exact to="/dashboard/salary-project/list" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("List of active salary cards")}</NavLink>
                            </div>
                        </div>
                        <div className="dashboard-salary-order-container">
                            {payload && <>
                                <div className="dashboard-salary-order-container-box">
                                    <div className="dashboard-salary-order-container-box-select dashboard-salary-order-container-box-select-filter">
                                        <label>{t("Type of operation")}</label>
                                        <FormControl className='dashboard-payment-container-data-section-content-container-form-select-box-multiple' sx={{ width: "100%" }}>
                                            <Select
                                                required
                                                multiple
                                                displayEmpty
                                                value={formData.services}
                                                onChange={(event) => this.setValues(event.target.value.includes('selectAll') ? (formData.services.length === payload.services.length ? [] : payload.services) : event.target.value, "services")}
                                                input={<OutlinedInput />}
                                                renderValue={(selected) => {
                                                    if (formData.services.length === payload.services.length)
                                                        return <p>{t('all')}</p>
                                                    return selected.map(option => option.description).join(', ')
                                                }
                                                }
                                                IconComponent={() => <KeyboardArrowDownOutlinedIcon color='disabled' className='mr-3' />}>
                                                <MenuItem value="selectAll">
                                                    <Checkbox defaultChecked checked={formData.services.length === payload.services.length} />
                                                    <ListItemText primary={t('all')} />
                                                </MenuItem>
                                                {payload.services.map((option) => (
                                                    <MenuItem key={option.id} value={option}>
                                                        <Checkbox checked={formData.services.indexOf(option) > -1} />
                                                        <ListItemText primary={option.description} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="dashboard-salary-order-container-box-select date dashboard-salary-order-container-box-select-filter">
                                        <label>{t("By date")}</label>
                                        <div className="dashboard-salary-order-container-box-select-datepicker">
                                            <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                                <StartDatePicker placeholder={t("Start date")} value={this.state.startDate} updateDate={this.updateDate} />
                                            </div>
                                            <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                                <EndDatePicker placeholder={t("End date")} value={this.state.endDate} updateDate={this.updateDate} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dashboard-salary-order-container-box-select dashboard-salary-order-container-box-select-filter">
                                        <label>{t("By status")}</label>
                                        <FormControl className='dashboard-payment-container-data-section-content-container-form-select-box-multiple' sx={{ width: "100%" }}>
                                            <Select
                                                required
                                                multiple
                                                displayEmpty
                                                value={formData.status}
                                                onChange={(event) => this.setValues(event.target.value.includes('selectAll') ? (formData.status.length === payload.status.length ? [] : payload.status) : event.target.value, "status")}
                                                input={<OutlinedInput />}
                                                renderValue={(selected) => {
                                                    return selected.map(option => option.description).join(', ')
                                                }}
                                                IconComponent={() => <KeyboardArrowDownOutlinedIcon color='disabled' className='mr-3' />}>
                                                <MenuItem value="selectAll">
                                                    <Checkbox checked={formData.status.length === payload?.status?.length} />
                                                    <ListItemText primary={t('all')} />
                                                </MenuItem>
                                                {payload?.status?.map((option) => (
                                                    <MenuItem key={option.id} value={option}>
                                                        <Checkbox checked={formData.status.indexOf(option) > -1} />
                                                        <ListItemText primary={option.description} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>

                                </div>
                                <div className="dashboard-salary-order-container-box justify-content-end">
                                    <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" onClick={this.getHistory}>{t("Search")}</button>
                                    <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.setState({ formData: { services: [], status: [] }, startDate: null, endDate: null })}>{t("Clear")}</button>
                                </div>
                            </>
                            }
                            {applications.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ minHeight: '70vh', justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                                </div>
                                : <>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{t("date")}</th>
                                                <th>{t("Type of operation")}</th>
                                                <th>{t("Number of cards")}</th>
                                                <th>{t("Status")}</th>
                                                <th>Excel</th>
                                                <th>{t("Application")}</th>
                                                <th>{t("ADOC")}</th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {applications.length !== 0 && applications.map(item => (
                                                <tr>
                                                    <td>{item.operationDate}</td>
                                                    <td>{item.operationName}</td>
                                                    <td>{item.cardCount}</td>
                                                    <td>{item.status}</td>
                                                    <td>
                                                        {item.excel ?
                                                            <button onClick={() => this.getFile(item.id, item.serviceId, item.excel)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M2.70039 2.4C2.70039 1.2402 3.64059 0.3 4.80039 0.3H14.2761L21.3004 7.32426V21.6C21.3004 22.7598 20.3602 23.7 19.2004 23.7H4.80039C3.64059 23.7 2.70039 22.7598 2.70039 21.6V2.4Z" stroke="#344054" stroke-width="0.6" />
                                                                    <path d="M14.4004 0L21.6004 7.2H16.8004C15.4749 7.2 14.4004 6.12548 14.4004 4.8V0Z" fill="#344054" />
                                                                    <g clip-path="url(#clip0_4_6327)">
                                                                        <path d="M7.68066 14.88H16.3207M7.68066 14.88V12.96C7.68066 12.4298 8.11047 12 8.64066 12H10.5607M7.68066 14.88V16.8C7.68066 17.3302 8.11047 17.76 8.64066 17.76H10.5607M16.3207 14.88V16.8C16.3207 17.3302 15.8909 17.76 15.3607 17.76H10.5607M16.3207 14.88V12.96C16.3207 12.4298 15.8909 12 15.3607 12H10.5607M10.5607 12V17.76" stroke="#344054" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                </svg>
                                                            </button> : null
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.application ?
                                                            <button onClick={() => this.getFile(item.id, item.serviceId, item.application)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M2.70039 2.4C2.70039 1.2402 3.64059 0.3 4.80039 0.3H14.2761L21.3004 7.32426V21.6C21.3004 22.7598 20.3602 23.7 19.2004 23.7H4.80039C3.64059 23.7 2.70039 22.7598 2.70039 21.6V2.4Z" stroke="#344054" stroke-width="0.6" />
                                                                    <path d="M14.4004 0L21.6004 7.2H16.8004C15.4749 7.2 14.4004 6.12548 14.4004 4.8V0Z" fill="#344054" />
                                                                    <path d="M15.0449 15.1168C14.4461 15.1168 13.6966 15.2212 13.4514 15.258C12.4367 14.1983 12.1479 13.5959 12.083 13.4353C12.171 13.2092 12.4772 12.3502 12.5207 11.2469C12.5422 10.6946 12.4255 10.2818 12.1738 10.0202C11.9226 9.75896 11.6185 9.73865 11.5313 9.73865C11.2255 9.73865 10.7126 9.89327 10.7126 10.9287C10.7126 11.8271 11.1314 12.7804 11.2472 13.0267C10.6372 14.803 9.98224 16.0189 9.84317 16.269C7.39189 17.1919 7.2002 18.0843 7.2002 18.3372C7.2002 18.7917 7.52387 19.063 8.06602 19.063C9.38324 19.063 10.5853 16.8516 10.784 16.4676C11.7196 16.0948 12.9717 15.8639 13.29 15.8088C14.2031 16.6786 15.2591 16.9107 15.6976 16.9107C16.0275 16.9107 16.8002 16.9107 16.8002 16.1162C16.8002 15.3785 15.8547 15.1168 15.0449 15.1168ZM14.9814 15.6383C15.6929 15.6383 15.8809 15.8736 15.8809 15.998C15.8809 16.0761 15.8513 16.3308 15.4699 16.3308C15.128 16.3308 14.5375 16.1331 13.9566 15.7043C14.1989 15.6725 14.5574 15.6383 14.9814 15.6383ZM11.4939 10.2442C11.5588 10.2442 11.6015 10.265 11.6367 10.3138C11.8414 10.5978 11.6764 11.5256 11.4755 12.2516C11.2817 11.6291 11.1362 10.6738 11.3409 10.3378C11.3809 10.2722 11.4266 10.2442 11.4939 10.2442ZM11.1484 15.8014C11.406 15.281 11.6947 14.5226 11.852 14.0937C12.1666 14.6204 12.5899 15.1095 12.8347 15.3746C12.0725 15.5353 11.4958 15.6958 11.1484 15.8014ZM7.71188 18.4066C7.69491 18.3865 7.6924 18.3441 7.70519 18.2931C7.732 18.1864 7.93695 17.6573 9.41928 16.9942C9.20703 17.3285 8.87521 17.8062 8.51069 18.1631C8.25409 18.4033 8.05429 18.5251 7.91682 18.5251C7.86764 18.5251 7.79989 18.5117 7.71188 18.4066Z" fill="#344054" />
                                                                </svg>
                                                            </button> : null
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.adoc ?
                                                            <button onClick={() => this.getFile(item.id, item.serviceId, item.adoc)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M19.2004 23.7H4.80039C3.64059 23.7 2.70039 22.7598 2.70039 21.6V2.4C2.70039 1.2402 3.64059 0.3 4.80039 0.3H14.2761L21.3004 7.32426V21.6C21.3004 22.7598 20.3602 23.7 19.2004 23.7Z" stroke="#344054" stroke-width="0.6" />
                                                                    <path d="M14.4004 0L21.6004 7.2H16.8004C15.4749 7.2 14.4004 6.12548 14.4004 4.8V0Z" fill="#344054" />
                                                                    <g clip-path="url(#clip0_4_6331)">
                                                                        <path d="M7.67969 12H16.3197M7.67969 13.92H16.3197M7.67969 15.84H16.3197M7.67969 17.76H14.3997" stroke="#344054" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                </svg>
                                                            </button> : null
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.deletable ?
                                                            <button onClick={() => this.setState({ item: item, open: true })}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                                                                    <path d="M10.6667 4.00004V3.46671C10.6667 2.71997 10.6667 2.3466 10.5213 2.06139C10.3935 1.8105 10.1895 1.60653 9.93865 1.4787C9.65344 1.33337 9.28007 1.33337 8.53333 1.33337H7.46667C6.71993 1.33337 6.34656 1.33337 6.06135 1.4787C5.81046 1.60653 5.60649 1.8105 5.47866 2.06139C5.33333 2.3466 5.33333 2.71997 5.33333 3.46671V4.00004M6.66667 7.66671V11M9.33333 7.66671V11M2 4.00004H14M12.6667 4.00004V11.4667C12.6667 12.5868 12.6667 13.1469 12.4487 13.5747C12.2569 13.951 11.951 14.257 11.5746 14.4487C11.1468 14.6667 10.5868 14.6667 9.46667 14.6667H6.53333C5.41323 14.6667 4.85318 14.6667 4.42535 14.4487C4.04903 14.257 3.74307 13.951 3.55132 13.5747C3.33333 13.1469 3.33333 12.5868 3.33333 11.4667V4.00004" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </button> : null
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.updatable ?
                                                            <button onClick={() => this.props.history.push(`/dashboard/salary-project/edit/order/${item.serviceId}/${item.id}`)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                                                                    <g clip-path="url(#clip0_4_6361)">
                                                                        <path d="M14.0003 14H8.66701M1.66699 14.3334L5.36651 12.9105C5.60313 12.8195 5.72145 12.774 5.83214 12.7146C5.93046 12.6618 6.02419 12.6009 6.11235 12.5324C6.21161 12.4554 6.30124 12.3658 6.48051 12.1865L14.0003 4.66671C14.7367 3.93033 14.7367 2.73642 14.0003 2.00004C13.264 1.26366 12.0701 1.26366 11.3337 2.00004L3.81385 9.51985C3.63458 9.69912 3.54494 9.78876 3.46792 9.88801C3.39951 9.97617 3.33859 10.0699 3.28582 10.1682C3.2264 10.2789 3.18089 10.3972 3.08988 10.6339L1.66699 14.3334ZM1.66699 14.3334L3.03907 10.766C3.13726 10.5107 3.18635 10.3831 3.27055 10.3246C3.34414 10.2735 3.43519 10.2542 3.52319 10.271C3.62388 10.2902 3.72058 10.3869 3.91398 10.5803L5.42004 12.0864C5.61344 12.2798 5.71014 12.3765 5.72937 12.4772C5.74617 12.5652 5.72685 12.6562 5.67576 12.7298C5.61729 12.814 5.48965 12.8631 5.23437 12.9613L1.66699 14.3334Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                </svg>
                                                            </button> : null
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                                        <ul className="dashboard-pagination">
                                            {this.state.currentPage != 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage - 1)}>{t('previous-page')}</a></li>}
                                            {
                                                Array.from({ length: this.state.lastPage }).map((item, index) => {
                                                    if (this.state.lastPage > 3) {
                                                        if (this.state.currentPage - 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    {this.state.currentPage > 2 && <li><a href="#" onClick={(e) => this.selectPage(e, 1)}>1</a></li>}

                                                                    {this.state.currentPage > 3 && <li><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage == index + 1) {
                                                            return (
                                                                <>
                                                                    <li className="active" ><a href="#" style={{ cursor: 'default' }} onClick={e => e.preventDefault()}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage + 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                    {this.state.currentPage < this.state.lastPage - 2 && <li ><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}

                                                                    {this.state.currentPage + 1 < this.state.lastPage && <li ><a href="#" onClick={(e) => this.selectPage(e, this.state.lastPage)}>{this.state.lastPage}</a></li>}
                                                                </>
                                                            )
                                                        }
                                                    } else {
                                                        return (
                                                            <li className={index + 1 == this.state.currentPage ? "active" : ""}><a href="#" style={this.state.lastPage == 1 ? { borderRadius: '5px' } : {}} onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                        )
                                                    }
                                                })

                                            }
                                            {this.state.currentPage != this.state.lastPage && this.state.lastPage > 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage + 1)}>{t('next-page')}</a></li>}
                                        </ul>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(History);